import { onSnapshot as listen, type Unsubscribe } from "firebase/firestore";

// The portal has nested subscriptions; retiring the document's tenant must
// dispose all of them and ignore callbacks already queued by the SDK.
export function createTenantListenerScope(): {
  onSnapshot: typeof listen;
  dispose: () => void;
} {
  let disposed = false;
  const subscriptions = new Set<Unsubscribe>();
  const onSnapshot = ((...args: unknown[]) => {
    if (disposed) return () => {};
    let active = true;
    const wrapped = args.map((arg) =>
      typeof arg === "function"
        ? (...values: unknown[]) => {
            if (active && !disposed) arg(...values);
          }
        : arg,
    );
    const stop = (listen as (...values: unknown[]) => Unsubscribe)(...wrapped);
    const unsubscribe = (): void => {
      active = false;
      stop();
      subscriptions.delete(unsubscribe);
    };
    subscriptions.add(unsubscribe);
    return unsubscribe;
  }) as typeof listen;
  return {
    onSnapshot,
    dispose: () => {
      disposed = true;
      for (const stop of subscriptions) stop();
    },
  };
}
